import React, {PropTypes} from 'react';
import moment from 'moment';
import DisplayIf from 'shared/DisplayIf.jsx';

const BundlingPurchaseGuide = ({
  visible,
  nextDate,
  onNextDateClick
}) => (
  <DisplayIf
    condition={visible}
    className="animated fadeIn alert alert-success text-center"
    style={{width: '100%', marginTop: '10px', marginBottom: 0}}>
    <span>
      {'Thank you. Please select '}
      <button
        className="btn btn-link"
        onClick={() => onNextDateClick(nextDate)}>
        {moment.parseZone(nextDate).format('MMM D')}
      </button>
      {' on the calendar to register for Doubles and Singles.'}
    </span>
  </DisplayIf>
);

BundlingPurchaseGuide.propTypes = {
  visible: PropTypes.bool,
  nextDate: PropTypes.object,
  onNextDateClick: PropTypes.func
};

BundlingPurchaseGuide.defaultProps = {
  visible: false,
  nextDate: ''
};

export default BundlingPurchaseGuide;



// WEBPACK FOOTER //
// ./src/features/shared/BundlingPurchaseGuide.jsx